import { ReactNode } from "react";

interface PendingApprovalLayoutProps {
  children: ReactNode;
}

const PendingApprovalLayout = ({ children }: PendingApprovalLayoutProps) => {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4">
      {children}
    </div>
  );
};

export default PendingApprovalLayout; 